(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('notEmpty', notEmpty);

    function notEmpty(CommonHelper) {
        return function(val) {
            return !CommonHelper.isEmpty(val);
        };
    }
})();